import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const PhasesStatesStyled = styled.div`
  /* Sin caja blanca: la página va sobre el fondo gris, como Usuarios, Etiquetas y Jobsites */
  .containerHeader {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    padding: 0;
    gap: 32px;
  }

  .sectionFirstText {
    width: 100%;

    h2 {
      font-size: 20px; /* título de página de Velora, igual que candidatos y favoritos */
      font-weight: 600;
      line-height: 1.2;
      color: ${tokens.color.text.primary};
    }
    h5 {
      font-size: 14px;
      font-weight: 400;
      color: ${tokens.color.text.tertiary};
      margin-bottom: 0;
    }
  }

  /* Fases y estados en dos columnas iguales; en pantallas estrechas, una debajo de otra */
  .containerSection {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 32px;
    width: 100%;

    @media screen and (max-width: 960px) {
      grid-template-columns: minmax(0, 1fr);
    }
  }

  .containerFunnel {
    width: 100%;
  }
`

export default PhasesStatesStyled
